module.exports = __webpack_public_path__ + "static/noprinter-noproblem-dc8a4fa0e3c6573f7d371a6ed39e581c.png";